
import maternity from '../../../../images/service_icon/maternity.png'
// import surgical from '../../../../images/service_icon/sergical.png'
import doctor from '../../../../images/service_icon/doctor.png'
import blood_donation_icon from '../../../../images/service_icon/blood_donation_icon.png'
import vaccine from '../../../../images/service_icon/vaccin.png'
import medicine_supply from '../../../../images/service_icon/medicine_supply.png'
import oralIcon from  '../../../../images/service_icon/oral_1.png';

export const serviceData=[
 { 
  img:maternity,
  title:"Maternity",
  description:'Our maternity services provide a nurturing and supportive environment for expectant mothers. We offer expert prenatal and postnatal care to ensure a safe and joyful journey to motherhood. ',

 },
 { 
  img:doctor,
  title:"Sergical",
  description:'Our state-of-the-art surgical department is equipped to handle a wide array of procedures, from minor surgeries to complex operations. Your safety and swift recovery are our top priorities',
  
 },
 { 
  img:medicine_supply,
  title:"24/7 Medicine",
  description:'We understand that health issues can arise at any time. That is why Doctor Care provides round-the-clock access to essential medications. We ensure you receive the care you need when you need it.'
  
 },
 { 
  img:oralIcon,
  title:"Oral Health",
  description:'A healthy smile is a confident smile. Our dedicated oral health services promote excellent dental hygiene and ensure your smile radiates with vitality.'
  
 },
 { 
  img:blood_donation_icon,
  title:"Blood Donation",
  description:'Join us in saving lives. Doctor Care actively participates in blood donation drives, fostering a culture of care and community by contributing to a vital resource for those in need.  '
  
 },
 { 
  img:vaccine,
  title:"Vaccination",
  description:'Protect your family and community with our comprehensive vaccination services. We provide a range of vaccines to keep you and your loved ones safe from preventable diseases.'
  
 }
]